import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Hide = createSvgIcon(
  <path d="M9.217 4.44A12.15 12.15 0 0 1 12 4.117c7.718 0 11.527 7.05 11.685 7.35l.277.525-.277.525c-.075.143-1.005 1.853-2.805 3.585l-1.605-1.604a14.617 14.617 0 0 0 2.1-2.505C20.4 10.506 17.227 6.366 12 6.366c-.277 0-.547.016-.818.038L9.217 4.44ZM1.59 0l22.402 22.402-1.59 1.59-5.272-5.272a11.917 11.917 0 0 1-5.137 1.148c-7.71.007-11.52-7.043-11.678-7.343L.037 12l.278-.525c.097-.188 1.59-2.947 4.537-5.025L0 1.59 1.59 0Zm4.897 8.078c-2.002 1.32-3.3 3.06-3.862 3.915.975 1.484 4.147 5.624 9.375 5.624 1.252 0 2.393-.24 3.405-.63l-2.235-2.234c-.36.15-.758.24-1.17.24a3 3 0 0 1-2.76-4.17L6.495 8.078h-.008Z" />,
  'Hide'
);

export { Hide };
